var _ = require('underscore');
var React = require("react");
const createReactClass = require("create-react-class");

var form = require('../../../deploynaut/js/Form.jsx');

const deployTriggers = {
	Submitted: 'Submitted',
	Approved: 'Approved',
	Rejected: 'Rejected',
	Invalidated: 'Invalidated',
	Started: 'Started',
	Successful: 'Successful',
	Failed: 'Failed'
};

const WebhookForm = createReactClass({
	getInitialState: function() {
		var state = {
			id: null,
			endpoint: "",
			deployTriggers: []
		};

		var integration = this.props.integration;
		if (integration && integration.options !== undefined) {
			state.id = integration.id;
			state.endpoint = integration.options.Endpoint;

			_.each(deployTriggers, function(value, index) {
				// CheckboxSet name and value needs to be the name, so we have to use the
				// display name for the key in our deployTriggers const
				var fullName = "Deploy" + index;
				if (integration.options[fullName]) {
					state.deployTriggers.push(index);
				}
			});
		}

		return state;
	},

	render() {
		return (
			<div className="integration-form">
				<p>On certain deployment events, you can set an endpoint to receive a JSON payload
					of your deployment via HTTP POST.</p>

				<form.Form
					ref="webhookForm"
					url={this.props.model.UpdateURL}
					securityID={this.props.model.InitialSecurityID}
					buttonTitle="Save"
					buttonSubmittingTitle="Saving"
					afterSuccess={this.props.afterSuccess}
				>
					<div className="form-group">
						<label htmlFor="Endpoint">HTTPS Endpoint</label>
						<form.Input
							name="Endpoint"
							required
							validationError="Please enter a valid endpoint"
							placeholder="https://foo.com/deployments"
							value={this.state.endpoint}
						/>
					</div>

					<div className="form-group">
						<label htmlFor="Hooks">Trigger webhook on these deployment events</label>
						<form.CheckboxSet
							name="Hooks"
							source={deployTriggers}
							value={this.state.deployTriggers}
						/>
					</div>

					<form.Hidden name="Type" value="Webhook" />
					<form.Hidden name="ID" value={this.state.id} />
				</form.Form>
			</div>
		);
	}
});

module.exports = WebhookForm;
